export const BASE_PRICE = 100
export const FLAT_PRICE_MULTIPLIER = 3

// Зеркало App\Services\GameBuilderPriceCalculator::computeBasePrices
export function computeBasePrices(packScale, roundTypes) {
  const basePrices = []
  let mainIndex = 0
  let lastMainBase = BASE_PRICE

  roundTypes.forEach(type => {
    if (type === 'main') {
      mainIndex += 1
      lastMainBase = packScale === 'flat' ? BASE_PRICE : BASE_PRICE * mainIndex
    }
    basePrices.push(lastMainBase)
  })

  return basePrices
}

export function defaultFlatPrice(basePrice) {
  return basePrice * FLAT_PRICE_MULTIPLIER
}

export function topicPrices(topic, basePrice, questionsCount) {
  if (topic.priceScale === 'flat') {
    const price = Number(topic.flatPrice) || defaultFlatPrice(basePrice)
    return Array.from({ length: questionsCount }, () => price)
  }
  return Array.from({ length: questionsCount }, (unused, index) => basePrice * (index + 1))
}
